
import { BusinessUnitAddressTypeInfoBase } from './business-unit-address.typeinfo.base';


export class BusinessUnitAddressTypeInfo extends BusinessUnitAddressTypeInfoBase {
}

export const BUSINESS_UNIT_ADDRESS_TYPE: BusinessUnitAddressTypeInfo = new BusinessUnitAddressTypeInfo();



